import { render, staticRenderFns } from "./AppendixChange.vue?vue&type=template&id=c0277b3c&scoped=true"
import script from "./AppendixChange.vue?vue&type=script&lang=js"
export * from "./AppendixChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0277b3c",
  null
  
)

export default component.exports